import { Component, OnInit } from "@angular/core";

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  children?: ChildrenItems[];
  permission?: string;
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab?: string;
  type?: string;
  permission?: string;
  icontype: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Inicio",
    type: "link",
    icontype: "nc-icon nc-bank",
  },
  {
    path: "/catalogos/ventas",
    title: "Ventas",
    type: "link",
    icontype: "fal fa-cash-register",
    permission: "VENTAS",
  },
  {
    path: "/catalogos",
    title: "Catálogos",
    type: "sub",
    icontype: "fal fa-archive",
    children: [
      {
        path: "descuentos",
        title: "Descuentos",
        icontype: "fal fa-percent",
        permission: "DESCUENTOS",
      },
      {
        path: "usuarios",
        title: "Usuarios",
        icontype: "fal fa-users",
        permission: "USUARIOS",
      }
    ],
  },
  {
    path: '/configuracion',
    title: 'Configuración',
    type: 'link',
    icontype: 'fas fa-cog',
    permission: 'CONFIGURACION'
  },
];

@Component({
  selector: "sidebar-cmp",
  templateUrl: "sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  isNotMobileMenu() {
    if (window.outerWidth > 991) {
      return false;
    }
    return true;
  }
  private token = JSON.parse(localStorage.getItem("jwtToken"));
  public perm = this.token.user.permisos;
  public user = this.token.user;

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
  }
}
